import React from 'react'

import { withTranslation } from 'react-i18next'

import ReservationErrorImg from 'assets/no-results-reservation.svg'
import {
  ErrorImage,
  ErrorMessage,
  ErrorText,
  ErrorTitle,
  ErrorWrapper,
  StyledLink
} from 'components/simple-search-box/styled'
import e2eClasses from 'helpers/automation'
import NAMESPACES from 'localization/constants/namespaces'

const ReservationSearchBoxError = ({ t }) => (
  <ErrorWrapper>
    <ErrorText>
      <ErrorTitle>{t('shopping.search-box-container.pnr-not-available')}</ErrorTitle>
      <ErrorMessage>
        {t('shopping.search-box-container.pnr-not-available.leave-comments')}
        <StyledLink
          e2eClass={e2eClasses('searchBox.reserveSuggestionsLink')}
          href={t('suggestions.url')}
          underline
          target="_blank"
        >
          {t('shopping.search-box-container.pnr-not-available.here')}
        </StyledLink>
        {t('shopping.search-box-container.pnr-not-available.options')}
      </ErrorMessage>
      <StyledLink
        e2eClass={e2eClasses('searchBox.reserveReturnsLink')}
        href={t('booking.reserve-administrator.refund-options-url')}
        underline
        target="_blank"
      >
        {t('shopping.search-box-container.pnr-not-available.returns')}
      </StyledLink>
      <StyledLink
        e2eClass={e2eClasses('searchBox.reserveFiscalCreditLink')}
        href={t('fiscal-credit.url')}
        underline
        target="_blank"
      >
        {t('shopping.search-box-container.pnr-not-available.request-receipt')}
      </StyledLink>
    </ErrorText>
    <ErrorImage src={ReservationErrorImg} alt={'reservation-error'} />
  </ErrorWrapper>
)

export default withTranslation(NAMESPACES.HOME)(ReservationSearchBoxError)
